import breakpoints from '~/helpers/breakpoints';

const selectors = {
  componentVideo: '.component-video',
  videoDesktop: '.autoplay-custom.desktop',
  videoMobile: '.autoplay-custom.mobile',
};

// Aggiungi uno scarto in pixel (ad esempio, 100px)
const viewportMargin = 100;

export default () => {
  const componentVideos = document.querySelectorAll(selectors.componentVideo);
  const isMobileMode = isMobile();

  function init() {
    setEventListeners();
    playVisibleVideos();
  }

  function setEventListeners() {
    window.addEventListener("resize", playVisibleVideos);
    window.addEventListener("DOMContentLoaded", playVisibleVideos);

    let playVisibleVideosTimeout;
    window.addEventListener("scroll", () => {
      clearTimeout(playVisibleVideosTimeout);
      playVisibleVideosTimeout = setTimeout(playVisibleVideos, 200);
    }, { passive: true });

    // Aggiungi un listener per la pausa dei video quando vengono messi in pausa manualmente
    componentVideos.forEach(componentVideo => {
      const desktopVideo = componentVideo.querySelector(selectors.videoDesktop);
      const mobileVideo = componentVideo.querySelector(selectors.videoMobile);

      if (desktopVideo) {
        desktopVideo.addEventListener("pause", () => {
          // Impedisci al video di ripartire automaticamente quando torni alla pagina
          desktopVideo.currentTime = 0;
        });
      }

      if (mobileVideo) {
        mobileVideo.addEventListener("pause", () => {
          // Impedisci al video di ripartire automaticamente quando torni alla pagina
          mobileVideo.currentTime = 0;
        });
      }
    });
  }

  function playVisibleVideos() {
    componentVideos.forEach(componentVideo => {
      const desktopVideo = componentVideo.querySelector(selectors.videoDesktop);
      const mobileVideo = componentVideo.querySelector(selectors.videoMobile);
      const isVisible = elementIsVisible(componentVideo, viewportMargin);

      if (desktopVideo) {
        if (isVisible) {
          const hasControls = desktopVideo.hasAttribute('controls');
          const isMuted = desktopVideo.hasAttribute('muted');
          const shouldPlay = !(hasControls && !isMuted);

          if (isMobileMode && mobileVideo) {
            if (shouldPlay) {
              mobileVideo.play();
            }
            desktopVideo.pause();
          } else {
            if (shouldPlay) {
              desktopVideo.play();
            }
            if (mobileVideo) {
              mobileVideo.pause();
            }
          }
        } else {
          // Se il componente non è visibile, metti entrambi i video in pausa
          desktopVideo.pause();
          if (mobileVideo) {
            mobileVideo.pause();
          }
        }
      }
    });
  }

  function isMobile() {
    return window.matchMedia(`(max-width: ${breakpoints.medium})`).matches;
  }

  function elementIsVisible(el, margin = 0) {
    if (!el) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom + margin >= 0 &&
      rect.right + margin >= 0 &&
      rect.top - margin <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left - margin <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  return Object.freeze({
    init,
  });
};
